import React, { useContext, useState } from 'react';
import { Grid, Typography, ListItemButton, Switch } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useMutation } from '@apollo/client';
import { t } from 'i18next';

import MemberLayout from '../../../components/layouts/MemberLayout';
import { AuthorizationContext } from '../../../contexts/AuthorizationContext';
import { ME } from '../../../graphql/auth';
import { OPT_OUT_OF_CONTESTS } from '../../../graphql/contest/contests';

const useStyles = makeStyles(() => ({
  title: {
    marginBottom: 16,
  },
  item: {
    height: 72,
  },
}));

const MemberLeaderboardPreferences: React.FC = () => {
  const classes = useStyles();
  const { user } = useContext(AuthorizationContext);
  const [optedOut, setOptedOut] = useState<boolean>(
    user?.optOutOfContests || false,
  );
  const [optOutOfContests] = useMutation(OPT_OUT_OF_CONTESTS, {
    refetchQueries: [ME],
  });

  const handleOptOut = async () => {
    setOptedOut(!optedOut);
    await optOutOfContests({ variables: { optOut: !optedOut } });
  };

  return (
    <MemberLayout>
      <Grid container direction="column">
        <Typography className={classes.title} variant="h2">
          {t('settings.leaderboardPreferences.title')}
        </Typography>
        <ListItemButton className={classes.item} onClick={handleOptOut}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h3">
              {t('settings.leaderboardPreferences.optOut')}
            </Typography>
            <Switch checked={optedOut} />
          </Grid>
        </ListItemButton>
      </Grid>
    </MemberLayout>
  );
};

export default MemberLeaderboardPreferences;
